<template>
  <div class="wrapper">
    <AppHeader />
    <Suspense>
      <template #default>
        <AppNotFounds />
      </template>
      <template #fallback>
        <AppLoading />
      </template>
    </Suspense>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from "@/components/layouts/AppHeader.vue";
import AppFooter from "@/components/layouts/AppFooter.vue";
import { defineAsyncComponent } from "vue";
import AppLoading from "@/components/Spinners/AppLoading.vue";
const AppNotFounds = defineAsyncComponent(() =>
  import('@/components/Pages/AppNotFounds.vue')
)
export default {
  name: 'NotFoundView',
  components: {
    AppHeader,
    AppFooter,
    AppNotFounds,
    AppLoading
  },
}
</script>

<style></style>